import { Grid, Typography } from "@mui/material";
import { EmployeeFilterDropdown } from "Components/Shared/Filters/EmployeeFilterDropdown";
import type { FilterOption } from "Components/Shared/Filters/FilterOption";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Components.Shared.Filters;

type Props = {
  value: FilterOption | undefined;
  onChange: (option: FilterOption | undefined) => void;
};

export const EmployeeFilter = ({ value, onChange }: Props) => {
  const { t } = useResource();

  return (
    <Grid size={{ xs: 12, sm: 6 }}>
      <Typography fontSize={13} fontWeight={400} mb={1}>
        {t(RESOURCES.Employee)}
      </Typography>
      <EmployeeFilterDropdown value={value} onChange={onChange} />
    </Grid>
  );
};
